module.exports = __webpack_public_path__ + "static/media/9DESA19.e6defdc2.jpg";